<div class="card p-4 flex mt-2">
  <div class="w-full mt-2 flex flex-col gap-4">
    <nz-skeleton
      [ngClass]="skeleton ? 'p-3' : 'p-0'"
      [nzLoading]="skeleton"
      [nzActive]="true"
    >
      <nz-card nzHoverable class="p-3 w-full">
        <div class="flex justify-between items-center">
          <div class="flex flex-col gap-2 w-[70%]">
            <span class="title">RajaOngkir Documentation </span>
            <p class="card-text">
              From shipping cost calculation to delivery management, payment services, and QRISLY documentation — we’ve got you covered.
            </p>
          </div>

          <a
            href="https://rajaongkir.com/docs"
            target="_blank"
          >
            <button
              nz-button
              nzDanger
              nzType="primary"
              class="rounded w-fit px-2 py-1 flex items-center justify-center gap-2"
            >
            Go to Docs
            <img src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/export.svg" alt="export-icon" class="w-4 h-4 mr-2">
            </button>
          </a>
        </div>
      </nz-card>
    </nz-skeleton>

    <nz-skeleton
      [ngClass]="skeleton ? 'p-3' : 'p-0'"
      [nzLoading]="skeleton"
      [nzActive]="true"
    >
      <nz-card nzHoverable class="p-3 w-full">
        <div class="flex justify-between items-center">
          <div class="flex flex-col gap-2 w-[70%]">
            <span class="title">Woocommerce Plugin</span>
            <p class="card-text">
              Connect your Woocommerce store with RajaOngkir, download directly
              here. For download and installation guidance,
              <a
                href="{{ link.rajaongkir }}"
                target="_blank"
                >you can access it here</a
              >
            </p>
          </div>

          <a
            href="{{ link.woocommerce }}"
            target="_blank"
          >
            <button
              nz-button
              nzDanger
              nzType="primary"
              class="rounded w-fit px-2 py-1 flex items-center justify-center gap-2"
            >
            Download Plugin
            <img src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/import-2.svg" alt="download-icon" class="w-4 h-4 mr-2">
            </button>
          </a>
        </div>
      </nz-card>
    </nz-skeleton>
  </div>
</div>
